import React from "react";
export var ProjectMinimumInput = /*#__PURE__*/ React.forwardRef(function BaseProjectMinimumInput(param, ref) {
    var checked = param.checked, name = param.name, onChange = param.onChange;
    return /*#__PURE__*/ React.createElement("div", {
        className: "project-minimum"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "charge-minimum",
        "data-testid": "charge-minimum-input",
        type: "checkbox",
        defaultChecked: checked,
        ref: ref,
        name: name,
        onChange: onChange
    }), /*#__PURE__*/ React.createElement("label", {
        htmlFor: "charge-minimum"
    }, "\xa0 Charge project minimum ($100)"));
});
